import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import { createTask, setOnboardingStep } from 'state/actions'

import {
	getCurrentUser,
} from 'state/selectors'

import { 
	isMobile,
	formatByTimeZone
} from 'utils'
import InputStandard from 'components/input/standard'

import Scroll from 'react-scroll'

import Onboarder from 'components/onboarder/onboarder'

import moment from 'moment'

class NewTask extends Component {
	scroll = Scroll.animateScroll

	state = {
		newTaskName: '',
		isFocused: false
	}

	updateNewTaskName = e => {
		this.setState({
			newTaskName: e.target.value
		})
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			const {
				milestone,
				currentProject
			} = this.props

			// Focus if new milestone (and not a duplicated project)
			if(this.inputRef && milestone && milestone.tasks && !milestone.tasks.length && currentProject){
				const secondsAgoMilestoneCreated = moment().diff(formatByTimeZone(milestone.created_at, null, true), 'seconds')
				const secondsAgoProjectCreated = moment().diff(formatByTimeZone(currentProject.created_at, null, true), 'seconds')

				if(secondsAgoMilestoneCreated < 15 && secondsAgoProjectCreated > 15){
					this.inputRef.inputRef.focus()
				}
			}
		},10)
	}

	createNewTask = _ => {
		const {
			addTempTask,
			milestone,
			forceAddVisibleId,
			createTask,
			setOnboardingStep,
			userData
		} = this.props

		if (!this.state.newTaskName) {
			return
		}

		addTempTask(this.state.newTaskName)

		this.setState({
			newTaskName: ''
		})

		createTask(this.state.newTaskName, milestone.id, task => {
			forceAddVisibleId(task)

			setOnboardingStep('CREATED_NEW_TASK', userData)
		})

		const distanceToScroll = isMobile() ? 140 : 40

		this.scroll.scrollMore(distanceToScroll, {
			duration: 1,
		})
	}

	handleFocus = isFocused => {
		if (isMobile() && this.props.handleInputFocus) {
			this.props.handleInputFocus(isFocused)
		}

		this.setState({
			isFocused
		})
	}

	handleOnFocus = _ => {
		const {
			isLast,
			scrollToBottom
		} = this.props

		// this is also react-scroll, so it's animated
		if (isLast && isMobile()) {
			scrollToBottom()
		}
	}

	handlePaste = e => {
		const {
			createTask,
			milestone,
			forceAddVisibleId
		} = this.props

		let pastedText = null

		if (window.clipboardData && window.clipboardData.getData) {
			pastedText = window.clipboardData.getData('Text')
		} else if (e.clipboardData && e.clipboardData.getData) {
			pastedText = e.clipboardData.getData('text/plain')
		}

		const pastedLines = pastedText.split("\n")
		const validLines = []

		pastedLines.forEach(line => {
			if(line && line !== ' '){
				if(line.startsWith('* ')){
					line = line.replace('* ','')
				}

				validLines.push(line)
			}
		})

		if(validLines.length && validLines.length > 1){
			validLines.forEach(line => {
				createTask(line, milestone.id, task => {
					forceAddVisibleId(task)
				})
			})

			setTimeout(_ => {
				this.setState({
					newTaskName: ''
				})
			})
		}
	}

	render() {
		const {
			milestoneIndex,
			currentProject
		} = this.props

		let className = "new-task clear task-list-item no-hover"

		if (this.state.isFocused) {
			className += ' focused'
		}

		return (
			<li className={className}>
				<InputStandard
					ref={ref => this.inputRef = ref}
					focusCallback={_ => {
						this.handleFocus(true)
						this.handleOnFocus()
					}}
					blurCallback={_ => { 
						this.handleFocus(false) 
					}}
					outlineOnFocus={true}
					callback={this.createNewTask}
					value={this.state.newTaskName}
					onChange={this.updateNewTaskName}
					placeholder="New task..."
					showPlus={true}
					onPaste={this.handlePaste}
				/>
				{ !milestoneIndex ?
					<Onboarder type='CREATED_TASK' direction="top-left" project={currentProject}/>
				: null }
			</li>
		);
	}
}


const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
	}
}

export default connect(mapStateToProps, { 
	createTask,
	setOnboardingStep
})(NewTask);  



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/project-tasks-new.jsx